// extracted by mini-css-extract-plugin
export default {"component":"VoucherPage_component__Lwo0N","horizontal":"VoucherPage_horizontal__SmjDP","vertical":"VoucherPage_vertical__Pnive"};